module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch3"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('p', {
    staticClass: "centerImage1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/ch3.jpg",
      "width": "13%"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("My heart skipped a beat. I let out a horrified cry — and gripped the railing with both hands.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("No. Please. Tell me I didn’t do it.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gasping for breath, I stared down over the rail.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sheena’s black hair spread out like a limp jellyfish on the surface of the ocean. Was she floating facedown?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No. She tilted her head up. “Hope I didn’t "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("scare")]), _vm._v(" you, Billy!” She raised the spear in one hand and waved it over her head, laughing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sheena, that’s not a good joke,” Dr. D said, shaking his head.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sure it was!” Sheena replied. “It worked!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("What a brat.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You didn’t scare me at all,” I said. My voice cracked. I hoped she didn’t notice.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sheena is ten, and she likes to prove that she’s the bold, brave one in the family. Maybe she "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is")]), _vm._v(" a little braver than me. But mainly she’s just loud and annoying.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Dr. D,” Sheena shouted, “you shouldn’t let Billy play with sharp things. He’ll poke his eye out.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I groaned. “Ha-ha. Toss up the spear and wait right there. I need the target practice.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You couldn’t hit the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ocean")]), _vm._v(" from there!” she cried. Then she laughed at her own dumb joke.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Come up here,” Dr. D called to her. “I need to talk to you both.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sheena climbed onto the deck. She pulled off her mask and her wet suit, straightened her red swimsuit, and shook out her hair.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("We look a lot alike. We both have straight black hair. Mine is short, and hers comes down past her shoulders.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("We’re both tall and kinda skinny. We both have dark blue eyes and heavy dark eyebrows that make us look serious, even when we’re not.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sometimes people say, “You two must be twins.” That makes me stick my finger down my throat and gag. Because first, I’m a whole two years older than she is and second, we’re not alike at all.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sheena doesn’t like to pretend. She would stare at the Albino Electric Eel and say, “That’s just a clump of seaweed.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("No way")]), _vm._v(" she could share the amazing adventures of the Undersea Mutant. She only likes things that are "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("real")]), _vm._v(". How boring is that?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sheena carried the spear across the deck and dropped it on my bare foot.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“OWWWW!” I screamed, hopping up and down.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("told")]), _vm._v(" you to be careful with that thing,” Sheena said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Maybe next summer, I’ll invite my "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("other")]), _vm._v(" niece and nephew to join me,” Dr. D said. “They get along.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We get along fine,” Sheena said. She wrapped her arm around my shoulders and gave me a big fake hug. “Don’t we, Billy-Willy?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Totally annoying, right?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No more target practice for today,” Dr. D said. “Take your places. It’s time to move. I just got the okay over the radio. And the navigation maps I’ve been waiting for arrived today via satellite. So we are ready for action!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He turned and headed up to the pilot’s cabin.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Where are we going?” I called after him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Deep waters,” he said. He looked back and frowned at us. “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Very")]), _vm._v(" deep waters.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a0fb3d8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780545840330_ch003.vue
// module id = 78
// module chunks = 0